export default {
  en: {
    pageTitle: 'Insights',
    beta: 'Beta',
    learnMore: 'Learn more',
    dataSourceOptions: {
      controls: 'Controls',
      suppliers: 'Suppliers',
      controlsComingSoon: 'Coming soon',
    },
    nestedDropdown: {
      back: 'Back',
      none: 'None',
      searchPlaceholder: 'Search...',
      noneMatchingTitle: 'No matching filters',
      noneMatchingBody: 'Try searching for something different',
      extraInfo: {
        questionInfo: 'Question info',
        learnMore: 'Learn more',
        answer: 'Answer',
      },
    },
    filterAttributes: {
      unknown: 'Unknown',
      controls: 'Controls',
      control_number: 'Control number',
      control_number_of_evidence_files: 'Number of evidence files',
      control_question: 'Question',
      answer: 'Answer',
      included_ids: 'Answer',
      modified_at: 'Modified at',
      is_compliant: 'Is compliant',
      compliance_status: 'Compliance status',
      compliant: 'Compliant',
      not_compliant: 'Not compliant',
      out_of_scope: 'Out of scope',
      child_out_of_scope: 'Child out of scope',
      policy_not_required: 'Policy not required',
      framework_not_required: 'Framework not required',
      required: 'Required',
      remediation_status: 'Remediation status',
      open_risk_count: 'Open risk count',
      discussion: 'Discussion',
      evidence_count: 'Evidence count',
      true: 'True',
      false: 'False',
      supplier_name: 'Supplier name',
      supplier_country: 'Country',
      supplier_company_number: 'Company number',
      supplier_industry: 'Industry',
      supplier_website: 'Website',
      applied_labels: 'Labels',
      confidentiality_tag: 'Confidentiality',
      criticality_tag: 'Criticality',
      holds_pii_tag: 'Holds PII',
      awaiting_response: 'Awaiting response',
      awaiting_review: 'Awaiting review',
      cancelled: 'Cancelled',
      completed: 'Completed',
      no_remediation: 'No remediation',
      is_out_of_scope: 'Is out of scope',
      is_not_applicable: 'Is not applicable',
      is_unanswered: 'Is unanswered',
      is_expired: 'Is expired',
      expiry_date: 'Expiry date',
      yes: 'Yes',
      no: 'No',
      review_state: 'Review status',
      review_expires_at: 'Review expiry',
      review_modified_at: 'Review last modified',
      review_modified_by: 'Review last modified by',
      domain: 'Domain',
      number_of_evidence_files: 'Evidence files count',
      control_open_risk_count: 'Open risk count',
      control_open_discussion: 'Open discussion count',
      required_count: 'Required count',
      not_required_count: 'Not required count',
      compliant_count: 'Compliant count',
      not_compliant_count: 'Not compliant count',
      compliant_without_overrides_count: 'Compliant without overrides count',
      override_count: 'Override count',
      exemption_count: 'Exemption count',
      compliance_percentage: 'Compliance percentage',
      num_policies_applied: 'Number of policies applied',
    },
    summarisationAttributes: {
      select_a_metric: 'Select a metric',
      select_a_grouping_field: 'Select a grouping field',
      count_of_suppliers: 'Count of suppliers',
      count_of_controls: 'Count of controls',
      sum_of: 'Sum of...',
      control_question_group: 'Question {0}',
      sum_of_control_question_group: 'Sum of question {0}',
      sum_of_open_risk_count: 'Sum of {0} open risk count',
      sum_of_evidence_count: 'Sum of {0} evidence count',
      average_of_control_question_group: 'Average of question {0}',
      average_of_open_risk_count: 'Average of {0} open risk count',
      average_of_evidence_count: 'Average of {0} evidence count',
      average_of: 'Average of...',
      compliance_percentage: 'Compliance percentage',
      num_policies_applied: 'Number of policies applied',
      average_of_compliance_percentage: 'Average of compliance percentage',
      average_of_num_policies_applied: 'Average of number of policies applied',
      supplier_count: 'Count of suppliers',
      control_count: 'Count of controls',
      open_risk_count: 'Open risk count',
      open_risk_count_sum: 'Sum of open risk count',
      open_risk_count_average: 'Average of open risk count',
      evidence_count: 'Evidence count',
      evidence_count_sum: 'Sum of evidence count',
      evidence_count_average: 'Average of evidence count',
      supplier_country: 'Country',
      supplier_industry: 'Industry',
      criticality_tag: 'Criticality',
      confidentiality_tag: 'Confidentiality',
      holds_pii_tag: 'Holds PII',
      applied_labels: 'Labels',
      open_discussion_count: 'Open discussion count',
      open_discussion_count_sum: 'Sum of open discussion count',
      open_discussion_count_average: 'Average of open discussion count',
      required_count: 'Required count',
      required_count_sum: 'Sum of required count',
      required_count_average: 'Average of required count',
      not_required_count: 'Not required count',
      not_required_count_sum: 'Sum of not required count',
      not_required_count_average: 'Average of not required count',
      compliant_count: 'Compliant count',
      compliant_count_sum: 'Sum of compliant count',
      compliant_count_average: 'Average of compliant count',
      not_compliant_count: 'Not compliant count',
      not_compliant_count_sum: 'Sum of not compliant count',
      not_compliant_count_average: 'Average of not compliant count',
      compliant_without_overrides_count: 'Compliant without overrides count',
      compliant_without_overrides_count_sum: 'Sum of compliant without overrides count',
      compliant_without_overrides_count_average: 'Average of compliant without overrides count',
      override_count: 'Override count',
      override_count_sum: 'Sum of override count',
      override_count_average: 'Average of override count',
      exemption_count: 'Exemption count',
      exemption_count_sum: 'Sum of exemption count',
      exemption_count_average: 'Average of exemption count',
      supplier_name: 'Supplier name',
      supplier_company_number: 'Company number',
      supplier_website: 'Website',
      domain: 'Domain',
      controls: 'Controls',
      review_state: 'Review status',
      review_modified_at: 'Review last modified',
      review_modified_by: 'Review last modified by',
    },
    dashboard: {
      yourQuestions: 'Your questions',
      predefinedQuestions: 'Common questions',
      add_new_question: 'Add a new question',
      delete: 'Delete',
      rename: 'Rename',
      duplicate: 'Duplicate',
      duplicateFailed: 'Something went wrong. Try duplicating again.',
      duplicateSuccess: 'Duplicate created!',
      deleteModalTitle: 'Delete question "{name}"',
      deleteModalDescription:
        'Are you sure you want to delete this question? Action cannot be reversed.',
      deleteModalConfirmButton: 'Delete',
      deleteModalCloseButton: 'Cancel',
      deleteModalFailed: 'Failed to delete question. Please try again.',
      renameModalTitle: 'Rename question "{name}"',
      renameModalNameInputLabel: 'New question name',
      renameModalFailed: 'Failed to rename question. Please try again.',
      renameModalNameRequired: 'Enter a new name for the question',
    },
    page: {
      newQuestion: 'New question',
      saveQuestion: 'Save question',
      revertChanges: 'Revert changes',
      results: '{count} result | {count} results',
      noResults: 'No results',
      noResultsText:
        "We couldn't find any results matching this query. Please try using different values or filters.",
      startFiltering: 'Start filtering',
      startFilteringText: 'Start your query by adding filters and the result will appear here.',
      error: 'We experienced an issue',
      errorText:
        'Please check your filters and refresh the page. If the issue still exists contact us.',
      form: {
        questionNameTitle: 'Question name',
        questionName: 'Enter a name...',
        questionNameError: 'Enter a question name in order to save it',
        selectDataSource: 'Select your data source',
        dataSourceRequired: 'Select a data source',
        addFilters: 'Add your filters',
        metricTitle: 'Metric',
        groupByTitle: 'Group by',
      },
      export: {
        button: 'Export',
        error: 'Failed to export. Please try again.',
        filename: 'insights-{date}.csv',
      },
      viewAll: 'View all',
    },
    unsavedModal: {
      title: 'Unsaved changes',
      description:
        'Are you sure you want to leave this page? All changes will be lost unless you save them.',
      leave: 'Leave',
      save: 'Save',
    },
    predefined: {
      criticalIso: 'Critical suppliers without ISO 27001 certification',
      dataOutOfUk: 'Suppliers who hold PII and transfer data out of the UK',
      mostNonCompliant: 'Most non-compliant controls',
      nonCompliantEnvSocGov: 'Non-compliant suppliers to XB.2, XB.13, XB.6',
    },
    columnModal: {
      title: 'Select columns',
      done: 'Done',
    },
  },
};
